import { Injectable } from '@angular/core';
import {
  CustomerOfferListItemResponse,
  CustomerOfferResponse,
  CustomerService,
  FiltersResponse,
  PaginatedApiResponseWithFilters,
  WorkCouncilOfferListItemResponse,
  WorkCouncilStatus,
} from '../../../api';
import { BaseListPagination } from '../../shared/enums/base-list-pagination.enum';
import {
  BaseCustomerOfferListOrderDirectionType,
  BaseCustomerOfferListOrderKeyType,
} from './_models/base-customer-offers.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class BaseOffersService {
  constructor(private customerService: CustomerService) {}

  getOffersList(params: {
    customer: number;
    statuses?: any;
    departments?: number;
    mainQualifications?: any;
    profileAverageRating?: number;
    pspBranches?: any;
    experience?: boolean;
    workCouncilStatus?: WorkCouncilStatus;
    search?: string;
    page?: any;
    size?: any;
    order?: string;
  }): Observable<
    PaginatedApiResponseWithFilters & {
      data?: Array<CustomerOfferListItemResponse | WorkCouncilOfferListItemResponse>;
      filters?: FiltersResponse;
    }
  > {
    return this.customerService.getCustomerOffersList({
      customer: params.customer,
      'statuses[]': params.statuses,
      'departments[]': params.departments,
      'mainQualifications[]': params.mainQualifications,
      profileAverageRating: params.profileAverageRating,
      'pspBranches[]': params.pspBranches,
      experience: params.experience,
      workCouncilStatus: params.workCouncilStatus,
      search: params.search,
      page: params.page || BaseListPagination.page,
      size: params.size || BaseListPagination.size,
      orderKey: params.order?.split(',')[0] as BaseCustomerOfferListOrderKeyType,
      orderDirection: params.order?.split(',')[1] as BaseCustomerOfferListOrderDirectionType,
    });
  }

  getOfferDetails(params: { customer: number; offer: number }): Observable<CustomerOfferResponse> {
    return this.customerService.getCustomerOffersShow(params).pipe(map((response) => response.data));
  }

  getCustomerOfferedDaysFile(params: { customer: number; offer: number }): Observable<any> {
    return this.customerService.getCustomerOfferOfferPositionFileDownload(params);
  }
}
